<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { NodeData } from '../types/flow-types';
	import { resolveFlowNodeTypeLabel } from '../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: timerMode = (data.timerMode as string) || 'delay';
	$: delayValue = Number(data.delay?.value ?? 0);
	$: delayUnits = (data.delay?.units as string) || 'sec';

	$: displayText =
		timerMode === 'delay'
			? delayValue > 0
				? `Wait ${delayValue} ${delayUnits === 'min' ? (delayValue === 1 ? 'minute' : 'minutes') : delayValue === 1 ? 'second' : 'seconds'}`
				: 'Set delay'
			: data.displayLabel || data.label || 'Wait for event';
	$: nodeTypeLabel = resolveFlowNodeTypeLabel('timer', data);
</script>

<BaseNode
	{id}
	type="timer"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={displayText}
	{nodeTypeLabel}
	{...$$restProps}
>
	<div class="timer-content">
		{timerMode === 'delay' ? 'Continue after the delay' : 'Continue on event'}
	</div>
</BaseNode>

<style>
	.timer-content {
		display: flex;
		flex-direction: column;
		gap: 6px;
		align-items: center;
		text-align: center;
		color: var(--flow-slot-muted);
		font-size: 0.75rem;
	}
</style>
